angular.module('articles_factories').factory('ArticlesYearListFactory', ['$resource', function ($resource) {
    return $resource('/api/v2.0/articles/years/', {}, {
        query: {
            isArray: true
        }
    });
}]);